var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "preview-question__range" }, [
    _c("label", { staticClass: "preview-question__label" }, [
      _vm._v(_vm._s(_vm.item.question) + " "),
      _vm.item.isRowAnswerRequired ? _c("span", [_vm._v("*")]) : _vm._e(),
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "ranking-scale-table mb-3" }, [
      _c("thead", [
        _c(
          "tr",
          [
            _c("th"),
            _vm._v(" "),
            _vm._l(_vm.item.ratingItems.choices, function (choice) {
              return _c("th", { key: choice }, [
                _vm._v("\n          " + _vm._s(choice) + "\n        "),
              ])
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.item.ratingItems.labels, function (label, indexLabel) {
          return _c(
            "tr",
            { key: label },
            [
              _c("td", [_vm._v(_vm._s(label))]),
              _vm._v(" "),
              _vm._l(
                _vm.item.ratingItems.choices,
                function (choice, indexChoice) {
                  return _c("td", { key: choice }, [
                    _c("div", { staticClass: "d-flex justify-center" }, [
                      _c("input", {
                        staticClass: "preview-question__item-radio",
                        attrs: {
                          type: "radio",
                          name: `rd-${_vm.item.id}-${indexLabel}`,
                          id: `rd-${_vm.item.id}-${indexLabel}-${indexChoice}`,
                          disabled: _vm.isDisabled(choice),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.setAnswers(label, choice)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", {
                        staticClass: "ma-0",
                        attrs: {
                          for: `rd-${_vm.item.id}-${indexLabel}-${indexChoice}`,
                        },
                      }),
                    ]),
                  ])
                }
              ),
            ],
            2
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _vm.item.isRowAnswerRequired
      ? _c("p", { staticClass: "preview-question__info" }, [
          _vm._v("* All rows are required"),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }